<div class="attendance-section" (click)="$event.stopPropagation()">
  <form [formGroup]="form">
    <div class="hidden sm:block">
      <mat-radio-group
        formControlName="type"
        class="flex flex-row gap-[1rem]"
        aria-label="Select an option"
      >
        <mat-radio-button class="present-radio-btn" [value]="1" [disabled]="disabled">Yes</mat-radio-button>
        <mat-radio-button class="absent-radio-btn" [value]="2" [disabled]="disabled">No</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="block sm:hidden">
      <mat-checkbox 
        class="mobile-checkbox"
        formControlName="typeMobile"
        [checked]="form.get('type')?.value === 1"
        (change)="form.get('type')?.setValue($event.checked ? 1 : 2)" >
      </mat-checkbox>
    </div>
  </form>
</div> 